import { Grid, Typography } from '@mui/material';

const NoResultsMessage = ({ message }) => (
  <Grid
    container
    justifyContent="center"
    sx={{
      mt: 5,
    }}
  >
    <Typography
      align="center"
      sx={{
        pb: { xs: 0, sm: 1.25 },
        color: 'black',
        fontWeight: 600,
        fontSize: 14,
        m: { xs: '1rem 0', sm: 0 },
        lineHeight: { xs: 1, sm: 'initial' },
      }}
    >
      {message ??
        'Sin resultados en esta zona del mapa. Buscá en otra zona del mapa para ver más opciones.'}
    </Typography>
  </Grid>
);

export default NoResultsMessage;
